// localStorage key for persisting admin view state
const ADMIN_VIEW_STORAGE_KEY = 'cyrano-admin-view-enabled'

/**
 * Retrieves the stored admin view state from localStorage.
 * @returns The stored admin view state, defaulting to true if not found or on error
 */
export const getStoredAdminViewState = (): boolean => {
  try {
    const stored = localStorage.getItem(ADMIN_VIEW_STORAGE_KEY)
    // Default to true (admin view enabled) if no stored value
    return stored !== null ? JSON.parse(stored) : true
  } catch (error) {
    console.warn('Failed to read admin view state from localStorage:', error)
    return true // Default fallback
  }
}

/**
 * Saves the admin view state to localStorage.
 * @param enabled - Whether admin view is enabled
 */
export const setStoredAdminViewState = (enabled: boolean): void => {
  try {
    localStorage.setItem(ADMIN_VIEW_STORAGE_KEY, JSON.stringify(enabled))
  } catch (error) {
    console.warn('Failed to save admin view state to localStorage:', error)
  }
}
